import { AdditionalService } from '@cemex-core/cmx-api';
import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { AdditionalServicesSpecificationActionTypes, AdditionalServicesSpecificationActions } from '../actions/additional-services.actions';

export interface AdditionalServicesState {
  loading: boolean;
  additionalServices: AdditionalService[];
  maneuverSelected: boolean;
  maneuverValidated: boolean;
  maneuverable: boolean;
}

export const initialState: AdditionalServicesState = {
  loading: false,
  additionalServices: [],
  maneuverSelected: undefined,
  maneuverValidated: false,
  maneuverable: false,
};

export function additionalServicesReducer(
  state = initialState,
  action: AdditionalServicesSpecificationActions | OrderBuilderActions,
): AdditionalServicesState {
  switch (action.type) {
    case AdditionalServicesSpecificationActionTypes.LOAD: {
      return {
        ...state,
        ...initialState,
        loading: true,
      } as AdditionalServicesState;
    }
    case AdditionalServicesSpecificationActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        additionalServices: action.payload,
      } as AdditionalServicesState;
    }
    case AdditionalServicesSpecificationActionTypes.SET_MANEUVER_VALUE: {
      return {
        ...state,
        maneuverSelected: action.payload,
      } as AdditionalServicesState;
    }
    case AdditionalServicesSpecificationActionTypes.SET_MANEUVERABLE: {
      return {
        ...state,
        maneuverable: action.payload,
      } as AdditionalServicesState;
    }
    case AdditionalServicesSpecificationActionTypes.SET_MANEUVER_VALIDATION: {
      return {
        ...state,
        maneuverValidated: action.payload,
      } as AdditionalServicesState;
    }
    case RESET_BUILDER:
    case AdditionalServicesSpecificationActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
